import { useEffect, useState } from "react";
import { GetAllRole } from "../../../services/roleService";
import { useNavigate } from "react-router-dom";

const RoleList = () => {
    const navigate=useNavigate();
    const [roleData, setRoleData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const response = await GetAllRole();
                const data = response.data;
                if (response.statusCode === 200 && response.success === true) {
                    setError("");
                    setRoleData(data);
                }
                else {
    setError("something went wrong");
}
            } catch (error) {

    console.log(error);
    setError(error.message || "Something went wrong");
}finally {
            setLoading(false);
        }
        }

fetchData();
    }, []);
return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">Role List</h4>
                </div>

                <div className="card-body">
                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <>
                         {/* Total Records */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">
                    Total Records: 
                    <span className="badge bg-primary ms-2">
                        {roleData.length}
                    </span>
                </h5>
                 <button
        className="btn btn-success"
        onClick={() => navigate("/addstaffrole")}
    >
        + Add New Role
    </button>
            </div>
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover align-middle">
                                <thead className="table-dark">
                                    <tr>
                                        <th>#</th>
                                        <th>Role Name</th>
                                        <th>Parent Role</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {roleData.length > 0 ? (
                                        roleData.map((role, index) => (
                                            <tr key={role.id}>
                                                <td>{index + 1}</td>
                                                <td>{role.roleName}</td>
                                                <td>
                                                    {role.parentRolename || "-"}
                                                </td>
                                                <td>
                                                    <span
                                                        className={`badge ${
                                                            role.status ===
                                                            "Active"
                                                                ? "bg-success"
                                                                : "bg-danger"
                                                        }`}
                                                    >
                                                        {role.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="4"
                                                className="text-center"
                                            >
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
export default RoleList;